import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { Disability } from "Globals/Models/Disability";

export class DisabilityStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private disability: Disability[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.disability = initialState.disabilities;
    }

    @MobX.action
    public getDisabilityName(disabilityId: string | null): string {
        if (disabilityId == "0" || disabilityId == null || disabilityId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => disabilityId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): Disability[] {
        return this.disability.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getDisabilityOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
